import React from 'react';
export function Footer() {
  return <footer className="w-full bg-moss text-cream/70" data-id="element-31" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-3 px-5 py-8 pb-24 text-center sm:flex-row sm:justify-between sm:px-6 sm:py-10 sm:text-left md:pb-10" data-id="element-32" data-mp="3gfsnyg23r0ok">
        <p className="font-display text-lg text-cream" data-id="element-33" data-mp="36pfufycb7x6a">
          Método Maestro Jabonero
        </p>
        <p className="font-sans text-xs leading-relaxed text-cream/60" data-id="element-34" data-mp="3ufa4671c15mb">
          Producto digital. Los archivos se envían por email tras la
          confirmación del pago.
        </p>
      </div>
    </footer>;
}